/**
 * CourtyardScene: the wide painting of Xenia's courtyard, seen from the gate.
 * Renders nothing until the painting exists.
 *
 * The picture is shown whole, with any words above or below it and never laid
 * over it. That keeps the text readable whatever the painting turns out to
 * look like.
 */
import React from 'react';
import { clsx } from 'clsx';
import ArtImage from './ArtImage';
import { getArt } from './artFiles';
import { SCENES } from '../../data/artwork';

const scene = SCENES.courtyard;

export const hasCourtyardScene = () => Boolean(getArt(scene.file));

const CourtyardScene = ({ sizes = '(min-width: 896px) 864px, 100vw', eager = false, className }) => {
  if (!hasCourtyardScene()) return null;

  return (
    <ArtImage
      stem={scene.file}
      alt={scene.alt}
      width={1920}
      height={1080}
      sizes={sizes}
      eager={eager}
      className={clsx('block w-full h-auto', className)}
    />
  );
};

export default CourtyardScene;
